module.exports = __webpack_public_path__ + "img/footer_01_fanfan.e4782941.png";